<div class="admin-container">
  <h2>{{pageTitle}}</h2>

  <div class="search-header">
    <!-- TABS -->
    <div class="tabs-container">
      <div class="tabs">
        <button (click)="changeAll()" class="tab" [class.active]="activeTab === 'all'">Todos
          <!-- <span class="count">({{totalTodosUsuarios}})</span> -->
        </button>
        <button (click)="changeUserType(userTypesEnum.Customer.id)" class="tab" [class.active]="activeTab === 'customers'">Usuarios
        </button>
        <button (click)="changeUserType(userTypesEnum.Coach.id)" class="tab" [class.active]="activeTab === 'coaches'">Mentores
        </button>
        <button (click)="changeUserType(userTypesEnum.Expert.id)" class="tab" [class.active]="activeTab === 'experts'">Expertos
        </button>
        <button (click)="changeUserType(userTypesEnum.Administrator.id)" class="tab" [class.active]="activeTab === 'administrators'">Administrativos
        </button>
      </div>
    </div>
    <!-- SEARCH BAR -->
    <div class="search-controls">
      <div class="search-container">
        <div class="search-box">
          <input type="text" [(ngModel)]="searchTerm" (input)="searchUsers()" placeholder="Buscar usuario" class="search-input">
          <button class="search-button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
          </button>
        </div>
      </div>
      <!-- BOTON CREAR -->
      <!-- <button (click)="newAccount()" class="btn-create">
        Crear nueva cuenta
      </button> -->
    </div>

  </div>


  <div class="table-container">
    <div class="loader" *ngIf="loading">Cargando...</div>

    <table *ngIf="!loading && users.length > 0">
      <thead>
        <tr>
          <th>Nombre y Apellido</th>
          <th>Correo</th>
          <th>Estado</th>
          <th>Tipo</th>
          <th>Fecha Ingreso</th>
          <!-- <th>Acción</th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of users">
          <td>{{ user.name }}</td>
          <td>{{ user.email }}</td>
          <td>{{ user.status.name }}</td>
          <td>
            <select [(ngModel)]="user.selectedUserTypeId" name="userTypeCategory_{{user.id}}" (change)="updateUserType(user, $event)">
              <!-- <option value="0" disabled>Sin tipo</option> -->
              <option *ngFor="let item of userTypes" [value]="item.id">
                {{ item.name }}
              </option>
            </select>
          </td>
          <td>{{ user.createdAt | date : "dd/MM/yyyy" }}</td>

          <!-- <td>
            <button (click)="editarUsuario(user)" class="btn-editar">Editar</button>
          </td> -->
        </tr>
      </tbody>
    </table>

    <div class="empty-state" *ngIf="!loading && users.length === 0">
      No hay usuarios para mostrar
    </div>
  </div>

  <!-- MODAL CREAR USUARIO -->
  <div class="modal-overlay" *ngIf="showModalForm" (click)="closeModalForm()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>{{editMode ? 'Editar' : 'Agregar'}} experto</h2>
        <button class="close-button" (click)="closeModalForm()">×</button>
      </div>

      <div class="modal-body">
        <form [formGroup]="usuarioFormGroup" (ngSubmit)="guardarUsuario()" class="example-container">
          <!-- FILA -->
          <div class="form-row">
            <div class="form-group">
              <label>Nombre*</label>
              <input type="text" class="" placeholder="Nombre" formControlName="NOMBRE">
              <div *ngIf="frmUsuario['NOMBRE'].invalid && (frmUsuario['NOMBRE'].dirty || frmUsuario['NOMBRE'].touched)">
                <span class="text-danger" *ngIf="frmUsuario['NOMBRE'].hasError('required')">Nombre requerido</span>
              </div>
            </div>

            <div class="form-group">
              <label>Apellidos*</label>
              <input type="text" class="" placeholder="Apellido" formControlName="APELLIDO">
              <div *ngIf="frmUsuario['APELLIDO'].invalid && (frmUsuario['APELLIDO'].dirty || frmUsuario['APELLIDO'].touched)">
                <span class="text-danger" *ngIf="frmUsuario['APELLIDO'].hasError('required')">Apellido requerido</span>
              </div>
            </div>
          </div>
          <!-- FILA -->
          <div class="form-row">
            <div class="form-group">
              <label>Correo</label>
              <input type="email" class="" placeholder="Email" formControlName="EMAIL">
              <div *ngIf="frmUsuario['EMAIL'].invalid && (frmUsuario['EMAIL'].dirty || frmUsuario['EMAIL'].touched)">
                <span class="text-danger" *ngIf="frmUsuario['EMAIL'].hasError('required')">Correo requerido</span>
                <span class="text-danger" *ngIf="frmUsuario['EMAIL'].hasError('email')">Correo no válido</span>
              </div>
            </div>

            <div class="form-group">
              <label>Celular*</label>
              <input type="number" class="" style="width: 19%;margin-right: 2px;" placeholder="Code" formControlName="CODETELEFONO">
              <input type="number" class="" style="width: 80%;" placeholder="Celular" formControlName="TELEFONO">
            </div>
          </div>
          <!-- FILA -->
          <div class="form-row">
            <div class="form-group">
              <label>Fecha de Ingreso</label>
              <input type="date" class="" formControlName="FECHAINGRESO">
              <div *ngIf="frmUsuario['FECHAINGRESO'].invalid && (frmUsuario['FECHAINGRESO'].dirty || frmUsuario['FECHAINGRESO'].touched)">
                <span class="text-danger" *ngIf="frmUsuario['FECHAINGRESO'].hasError('required')">Fecha requerida</span>
              </div>
            </div>

            <div class="form-group">
              <label>Categoría</label>
              <!-- <select formControlName="CATEGORIAEXPERTO">
                <option value="0" disabled>Sin categoría</option>
                <option *ngFor="let item of expertCategories" [ngValue]="item.id">
                  {{item.name}}
                </option>
              </select> -->
              <div *ngIf="frmUsuario['CATEGORIAEXPERTO'].invalid && (frmUsuario['CATEGORIAEXPERTO'].dirty || frmUsuario['CATEGORIAEXPERTO'].touched)">
                <span class="text-danger" *ngIf="frmUsuario['CATEGORIAEXPERTO'].hasError('required')">Categoría requerida</span>
              </div>
            </div>
          </div>
          <!-- FILA -->
          <div class="form-row">
            <div class="form-group">
              <button type="submit" class="btn-cancel" (click)="closeModalForm()">Cancelar</button>
            </div>

            <div class="form-group">
              <button type="submit" class="btn-save" [disabled]="usuarioFormGroup.invalid">Guardar</button>
            </div>
          </div>

        </form>
      </div>

      <div class="modal-footer">
        <!-- <button class="cancel-button" (click)="closeModalForm()">Cerrar</button> -->
      </div>
    </div>
  </div>

</div>